import React, { useState } from 'react';
import { bundleHistory, fileExport } from '../../../api-services';
import { useDispatch } from 'react-redux';
import {
  openModalGlobal,
  openUserDetailsModal,
} from '../../../redux/features/modalSlice';
import Country from '../../../components/Country';
import moment from 'moment';
import { createTable } from '@tanstack/react-table';
import TableManager from '../../../components/TableManager';
import { Country as GlobalCountries } from 'country-state-city';
import { useMutation } from 'react-query';
import swal from 'sweetalert';

const table = createTable();
const numberFilterTypes = [
  { label: 'Less Than', value: 'less_than' },
  { label: 'Greater Than', value: 'greater_than' },
  { label: 'Is Equal To', value: 'is_equal' },
  { label: 'Is Not Equal To', value: 'is_not_equal' },
  { label: 'Less or Equal to', value: 'less_or_equal' },
  { label: 'Greater or Equal to', value: 'greater_or_equal' },
];

const DateFilterTypes = [
  { label: 'Today', value: 'Today' },
  { label: 'Yesterday', value: 'Yesterday' },
  { label: 'Last 7 Days', value: 'Last 7 Days' },
  { label: 'Last 30 Days', value: 'Last 30 Days' },
  { label: 'This Month', value: 'This Month' },
  { label: 'Last Month', value: 'Last Month' },
  { label: 'Custom', value: 'Custom' },
];

const statusOptions = [
  { label: 'Active', value: 'A' },
  { label: 'Deactive', value: 'D' },
];
const bundleTypesOptions = [
  { label: 'CALL', value: 'CALL' },
  { label: 'SMS', value: 'SMS' },
  { label: 'VN', value: 'VN' },
];

const initialValues = {
  filter: [
    {
      account_number: '',
      a_filter_type: '',
      placeholder: 'Enter MSISDN...',
      type: 'number',
      shouldFilterOptionDisabled: false,
      filterOptions: numberFilterTypes,
      label: 'MSISDN',
    },
    {
      bundle_type: '',
      a_filter_type: '',
      placeholder: 'Select Bundle Type...',
      type: 'select',
      shouldFilterOptionDisabled: true,
      selectOptions: bundleTypesOptions,
      label: 'Bundle Type',
    },
    {
      country: '',
      a_filter_type: '',
      placeholder: 'Select Country...',
      type: 'select',
      shouldFilterOptionDisabled: true,
      selectOptions: GlobalCountries?.getAllCountries(),
      label: 'Country',
    },
    {
      date: {
        from: '',
        to: '',
      },
      a_filter_type: '',
      placeholder: 'Custom Date Range...',
      type: 'date',
      shouldFilterOptionDisabled: false,
      filterOptions: DateFilterTypes,
      selectOptions: [],
      label: 'Date',
    },
  ],
};

const BundleHistory = () => {
  const [filters, setFilters] = useState([]);
  const [openFilter, setOpenFilter] = useState(false);

  const { isLoading: isLoadingExporting, mutateAsync: mutateAsyncExport } =
    useMutation('fileExport', (payload) => fileExport(payload, 'bundle'), {
      onSuccess: (data) => {
        window.open(data?.data?.data);
      },
      onError: (error) => {
        swal({
          title: error?.response?.data?.message,
          type: 'danger',
          icon: 'error',
        });
      },
    });

  const dispatch = useDispatch();

  const handleOpenModal = (customer) => {
    if (!customer?.firstname) {
      return false;
    }
    dispatch(
      openModalGlobal({
        isOpen: true,
        isData: customer,
      }),
    );
  };

  const handleOpenUserDetails = (shouldOpen, data) => {
    if (!shouldOpen) {
      return false;
    }

    dispatch(
      openUserDetailsModal({
        userModalOpen: true,
        userModalData: data,
      }),
    );
  };

  const handleFileExport = async (payload) => {
    await mutateAsyncExport(payload);
  };

  const columns = [
    table.createDataColumn('created_at', {
      id: 'created_at',
      header: 'Date',
      cell: (props) => moment(props.getValue()).format('YYYY-MM-DD: HH:mm:ss'),
      isSortable: true,
    }),
    table.createDataColumn('expired_at', {
      id: 'expired_at',
      header: 'Expires At',
      isSortable: true,
    }),
    table.createDataColumn((row) => row?.customer?.msisdn, {
      id: 'msisdn',
      header: 'MSISDN',
      shouldPointer: true,
      cell: (props) => (
        <span
          className="hover-name"
          onClick={() =>
            handleOpenUserDetails(
              props.getValue(),
              props?.row?.original?.customer,
            )
          }
        >
          {props.getValue()}
        </span>
      ),
    }),
    table.createDataColumn((row) => row?.countries?.alpha2code, {
      id: 'country',
      header: 'Country',
      textAlign: 'left',
      cell: (props) => <Country isoCode={props.getValue()} />,
    }),
    table.createDataColumn((row) => row?.bundle?.period, {
      id: 'period',
      header: 'Period ( Month )',
      textAlign: 'left',
      isSortable: true,
    }),
    table.createDataColumn((row) => row?.bundle?.bundle_type, {
      id: 'bundle_type',
      header: 'Type',
    }),
    table.createDataColumn(
      (row) => {
        const cost = `${row?.bundle?.bundle} ${
          row?.bundle?.bundle_type === 'CALL' ? 'mins' : 'SMS'
        }`;

        return cost;
      },
      {
        id: 'cost',
        header: 'Bundle',
        isSortable: true,
      },
    ),
    table.createDataColumn(
      (row) => {
        const cost = `${row?.remaining_bundles} ${
          row?.bundle?.bundle_type === 'CALL' ? 'mins' : 'SMS'
        }`;

        return cost || '---';
      },
      {
        id: 'remaining_cost',
        header: 'Remaning Bundle',
        isSortable: true,
      },
    ),
    table.createDataColumn(
      (row) => {
        const buyerName = !row?.customer?.firstname
          ? '---'
          : ` ${row?.customer?.firstname || ''} ${row?.customer?.lastname || ''}
`;
        return buyerName;
      },
      {
        id: 'buyer_name',
        header: 'Buyer Name',
        isSortable: true,
        cell: (props) => (
          <span
            className="hover-name"
            onClick={() => handleOpenModal(props?.row?.original?.customer)}
          >
            {props.getValue()}
          </span>
        ),
      },
    ),
  ];
  return (
    <>
      <TableManager
        table={table}
        columns={columns}
        filter={filters}
        fetcherKey="bundleHistory"
        fetcherFn={bundleHistory}
        title="Bundle Report"
        shouldFilter={true}
        openFilter={openFilter}
        setOpenFilter={setOpenFilter}
        initialValues={initialValues}
        setFilters={setFilters}
        filters={filters}
        shouldExport={true}
        exportCtaFn={handleFileExport}
        isExporting={isLoadingExporting}
      />
    </>
  );
};

export default BundleHistory;
